import React, { useCallback, useEffect, useRef, useState } from "react";
import { loadStripe } from '@stripe/stripe-js';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { getPaymentStatus, supportEmail } from "../hooks/apiHandler";
import { Navigate } from "react-router-dom";
import { Button, Container, CircularProgress, Box, Typography } from "@mui/material";
import "./internalModel.css";
import { url } from "../hooks/commanFunc";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This is your test secret API key.
// const stripePromise = loadStripe("pk_test_51HgOpLHKoeQ5L0n6zqEQ0dIiaLkc9N54wXjLZrZSHo01AIf1wbhHk1vTVl3NF9BB6TmfP9yCV3a3wEOLCOP9kjMz002QgPgjqd");
const stripePromise = loadStripe("pk_live_51PM2Q4BcLGk2I7BylNZlk3R50mRCdaqnulaBfoBYFDSM8ih7Hl997dgVUNpGmUg5fcAiuUc0mJ59DdQLGPqge1Es00XWqFoR2d");

export const CheckoutForm = () => {
    const storeID = useRef(JSON.parse(window.localStorage.getItem("ds")));

    const fetchClientSecret = useCallback(() => {
        return fetch(url + "/api/stripe/create-checkout-session", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'  // <-- You missed this
            },
            body: JSON.stringify({ storeID: storeID.current })
        })
            .then((res) => res.json())
            .then((data) => data.clientSecret);
    }, []);

    const options = { fetchClientSecret };

    return (
        <div id="checkout">
            <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={options}
            >
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
        </div>
    )
}

export const Return = ({ onCloseTrigger }) => {
    const [status, setStatus] = useState(null); // Initial state is null to indicate loading
    const [customerEmail, setCustomerEmail] = useState('');

    useEffect(() => {
        const fetchPaymentStatus = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get('session_id');

            // Handle case where session_id is missing
            if (!sessionId) {
                setStatus('error');
                return;
            }

            try {
                const resp = await getPaymentStatus({ sessionId });
                if (resp) {
                    setStatus(resp.status);
                    setCustomerEmail(resp.customer_email);
                } else {
                    // Handle case where API response is not as expected
                    throw new Error("Invalid response from server");
                }
            } catch (error) {
                console.error("Error fetching payment status:", error);
                setStatus('error'); // Set an error state to show a message to the user
            }
        };

        fetchPaymentStatus();
    }, []); // Empty dependency array ensures this runs only once on mount

    // 1. Loading State: Show a spinner while the API call is in progress
    if (status === null) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <CircularProgress />
                <Typography sx={{ marginTop: 2 }}>Verifying payment, please wait...</Typography>
            </Box>
        );
    }

    // 2. Abandoned Checkout State
    if (status === 'open') {
        return <Navigate to="/admin" />;
    }

    // 3. Successful Payment State
    if (status === 'complete') {
        return (
            <Container>
                <section id="success" style={{ textAlign: "center", padding: "2rem" }}>
                    <div className="checkmark-wrapper">
                        <div className="checkmark-circle">
                            <div className="checkmark-stem"></div>
                            <div className="checkmark-kick"></div>
                        </div>
                    </div>
                    <Typography component="p" sx={{ marginTop: "2rem" }}>
                        We appreciate your business! A confirmation email will be sent to{" "}
                        <strong>{customerEmail}</strong>.
                        <br />
                        <br />
                        If you have any questions, please email{" "}
                        <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
                        <br />
                        <br />
                        <Button variant="contained" onClick={onCloseTrigger}>
                            Return
                        </Button>
                    </Typography>
                </section>
            </Container>
        );
    }

    // 4. Error State: Handle any failures gracefully
    return (
        <Container sx={{ textAlign: 'center', paddingY: 4 }}>
            <Typography variant="h5" color="error">Payment Status Could Not Be Determined</Typography>
            <Typography>
                There was an issue retrieving your payment details. Please check your email for a confirmation or contact support.
            </Typography>
            <Button variant="contained" onClick={onCloseTrigger} sx={{ marginTop: 2 }}>
                Close
            </Button>
        </Container>
    );
};